import React, { useState, useEffect } from "react";
import { VictoryPie, VictoryLabel } from "victory";
import {
  Button,
  Select,
  Stack,
  TextInput,
  MultiSelect,
  NumberInput,
  Group,
} from "@mantine/core";

import { EngagementContext } from "../../";

import RangeSlider from "./RangeSlider";

export default function Filters({
  completionPercentage,
  employeeCount,
  filteredCompletionPercentage,
  minsAndMaxs,
  totalEmployeeCount,
  totalResponsePercentage,
  values,
  onChange,
  onResetClick,
}) {
  const reportData = React.useContext(EngagementContext);

  const filtersApplied =
    values.ageMin ||
    values.ageMax ||
    values.department.length ||
    values.position.length ||
    values.race.length ||
    values.ethnicity.length ||
    values.gender.length ||
    values.salaryMin ||
    values.salaryMax ||
    values.tenureMin ||
    values.tenureMax
      ? true
      : false;

  const departmentOptions = reportData.departments
    .sort((a, b) => (a.text > b.text ? 1 : -1))
    .map((m) => ({
      label: m.text,
      value: m.value,
    }));

  const genderOptions = reportData.genders
    .sort((a, b) => (a.text > b.text ? 1 : -1))
    .map((m) => ({
      label: m.text,
      value: m.value,
    }));
  const ethnicityOptions = reportData.ethnicities
    .sort((a, b) => (a.text > b.text ? 1 : -1))
    .map((m) => ({
      label: m.text,
      value: m.value,
    }));

  const raceOptions = reportData.races
    .sort((a, b) => (a.text > b.text ? 1 : -1))
    .map((m) => ({
      label: m.text,
      value: m.value,
    }));
  const positionOptions = reportData.positions
    .sort((a, b) => (a.text > b.text ? 1 : -1))
    .map((m) => ({
      label: m.text,
      value: m.value,
    }));

  function onInputChange(name, value) {
    let newValues = { ...values };
    if (values[name] === undefined) return;
    return onChange({ ...newValues, [name]: value });
  }

  function onHourlyChange() {
    return onChange({
      ...values,
      payType: 2,
      salaryMin: "",
      salaryMax: "",
    });
  }

  return (
    <div className="filters">
      <Stack gap="sm">
        <MultiSelect
          label="Department"
          placeholder="Select some..."
          name="department"
          search
          onChange={(e, d) => {
            onInputChange("department", e);
          }}
          value={values.department}
          data={departmentOptions}
        />
        <MultiSelect
          label="Position"
          placeholder="Select some..."
          name="position"
          multiple
          search
          onChange={(e, d) => onInputChange("position", e)}
          value={values.position}
          data={positionOptions}
        />
        <MultiSelect
          label="Ethnicity"
          placeholder="Select some..."
          data={ethnicityOptions}
          name="ethnicity"
          multiple
          search
          onChange={(e, d) => onInputChange("ethnicity", e)}
          value={values.ethnicity}
        />
        <MultiSelect
          label="Race"
          placeholder="Select some..."
          data={raceOptions}
          name="race"
          multiple
          search
          onChange={(e, d) => onInputChange("race", e)}
          value={values.race}
        />
        <MultiSelect
          label="Gender"
          placeholder="Select some..."
          data={genderOptions}
          name="gender"
          multiple
          search
          onChange={(e, d) => onInputChange("gender", e)}
          value={values.gender}
        />
        <Group>
          <NumberInput
            label="Min Tenure"
            value={values.tenureMin}
            onChange={(e) => onInputChange("tenureMin", e)}
          />
          <NumberInput
            label="Max Tenure"
            value={values.tenureMax}
            onChange={(e) => onInputChange("tenureMax", e)}
          />
        </Group>
        <Group>
          <NumberInput
            label="Min Age"
            value={values.ageMin}
            onChange={(e) => onInputChange("ageMin", e)}
          />
          <NumberInput
            label="Max Age"
            value={values.ageMax}
            onChange={(e) => onInputChange("ageMax", e)}
          />
        </Group>
        {values.payType === 1 && (
          <Group>
            <NumberInput
              label="Min Salary"
              value={values.salaryMin}
              onChange={(e) => onInputChange("salaryMin", e)}
            />
            <NumberInput
              label="Max Salary"
              value={values.salaryMax}
              onChange={(e) => onInputChange("salaryMax", e)}
            />
          </Group>
        )}
      </Stack>
      {/* <RangeSlider
        label="Age (years)"
        min={minsAndMaxs.ageMin}
        max={minsAndMaxs.ageMax}
        step={1}
        onMinChange={(val) => onInputChange('ageMin', val)}
        onMaxChange={(val) => onInputChange('ageMax', val)}
      />
      <RangeSlider
        label="Tenure (years)"
        min={minsAndMaxs.tenureMin}
        max={minsAndMaxs.tenureMax}
        step={1}
        onMinChange={(val) => onInputChange('tenureMin', val)}
        onMaxChange={(val) => onInputChange('tenureMax', val)}
      />
      <RangeSlider
        label="Salary ($)"
        min={minsAndMaxs.salaryMin}
        max={minsAndMaxs.salaryMax}
        step={1000}
        onMinChange={(val) => onInputChange('salaryMin', val)}
        onMaxChange={(val) => onInputChange('salaryMax', val)}
      /> */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "1em" }}
      >
        <Donut
          value={
            filtersApplied ? filteredCompletionPercentage : completionPercentage
          }
          title={`Finished`}
          // title={`${employeeCount}/${totalEmployeeCount} Employee${
          //   employeeCount === 1 ? '' : 's'
          // }${filtersApplied ? ' matching these filters' : ''}`}
        />
        <Donut
          value={(employeeCount / totalEmployeeCount) * 100}
          title={
            !filtersApplied
              ? `${totalEmployeeCount} Employees`
              : `${employeeCount}/${totalEmployeeCount} of Employees Filtered`
          }
          // title={`${employeeCount}/${totalEmployeeCount} Employee${
          //   employeeCount === 1 ? '' : 's'
          // }${filtersApplied ? ' matching these filters' : ''}`}
        />
      </div>
      {filtersApplied && <Button onClick={onResetClick}>Clear Filters</Button>}
    </div>
  );
}

Filters.defaultProps = {
  employeeCount: 0,
  filteredCompletionPercentage: 0,
  totalEmployeeCount: 0,
  totalResponsePercentage: 0,
  values: {
    ageMax: "",
    ageMin: "",
    department: [],
    ethnicity: [],
    gender: [],
    race: [],
    salaryMax: "",
    salaryMin: "",
    tenureMax: "",
    tenureMin: "",
  },
};

function Donut({ value, title }) {
  const data = [
    { x: 1, y: value },
    { x: 2, y: 100 - value },
  ];

  return (
    <div className="donut">
      <svg viewBox="0 0 200 160" width="125px" height="80px">
        <VictoryPie
          standalone={false}
          width={200}
          height={200}
          data={data}
          innerRadius={60}
          // animate={{
          //   duration: 2
          // }}
          cornerRadius={25}
          labels={() => null}
          style={{
            data: {
              fill: ({ datum }) => {
                const color = datum.y > 68 ? "#37bcc8" : "#ff6666";
                return datum.x === 1 ? color : "transparent";
              },
            },
          }}
        />
        <VictoryLabel
          textAnchor="middle"
          verticalAnchor="middle"
          x={100}
          y={100}
          text={`${Math.round(value * 100) / 100}%`}
          style={{ fontSize: 20, fontFamily: "Open Sans", fontWeight: 700 }}
        />
      </svg>
      <p>{title}</p>
    </div>
  );
}

Donut.defaultProps = {
  value: 0,
  title: "Donut",
};
